export { default } from './offer-group.vue'
